import { takeEmployeeCallback } from "./auth/employeeCallback";

if (window.location.pathname === "/login/callback") {
  // Scrub before importing any UI or starting a network request. The normal app,
  // analytics, reCAPTCHA and Dynatrace never run in this document.
  const callback = takeEmployeeCallback();
  import("./auth/employeeCallbackPage").then(({ renderEmployeeCallback }) =>
    renderEmployeeCallback(callback)
  );
} else {
  const monitoring = document.createElement("script");
  monitoring.src =
    "https://js-cdn.dynatrace.com/jstag/17b5f18726d/bf03021ntv/5d2b94c69e6c6202_complete.js";
  monitoring.crossOrigin = "anonymous";
  document.head.appendChild(monitoring);
  import("./storefront");
}
